import { TaskSubTicketStatus } from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/resources/TaskSubTicketResource';
import { CSSProperties } from 'react';

import taskSubTicketStatusInformation from '@app/data/consts/taskSubTicketStatusInformation';

// Only Complete is filled. Every other phase status is outlined, so a board of in-flight work
// reads as outlines and the finished phases are the only solid blocks on the screen — the
// distinction the eye picks up first is the one that matters.
export const isFilledSubTicketStatus = (status: TaskSubTicketStatus): boolean => status === 'complete';

export const getSubTicketStatusTagStyle = (status: TaskSubTicketStatus): CSSProperties => {
    const { color } = taskSubTicketStatusInformation[status];

    if (isFilledSubTicketStatus(status)) {
        return { background: color, color: '#FFFFFF', border: `1px solid ${color}` };
    }

    return { background: 'transparent', color, border: `1px solid ${color}` };
};
